import find from 'lodash/find';

export const removeArrayItem = (arr, elementKey, elementValue) => {
  if (!Array.isArray(arr)) return arr;

  const index = arr.findIndex(item => item[elementKey] === elementValue);

  if (index !== -1) {
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }

  return arr;
};

// TODO: make it immutable
export const updateArrayItem = (arr, findObject, newValues) => {
  if (!Array.isArray(arr)) return arr;

  const elem = find(arr, findObject);

  if (elem) Object.assign(elem, newValues);

  return arr;
};

export const updateOrPush = (arr, findObject, newElement) => {
  if (!Array.isArray(arr)) return arr;

  const array = [...arr];

  const elem = find(array, findObject);

  if (!elem) {
    array.push(newElement);
  } else {
    Object.assign(elem, newElement);
  }

  return array;
};

export function findAndReplace(list, item, addIfEmpty = false) {
  const result = [...list];

  const index = list.findIndex(({ id }) => id === item.id);

  if (index >= 0) {
    result[index] = item;
  } else if (addIfEmpty) {
    result.push(item);
  }

  return result;
}

export function toggleElementInList(list, id) {
  const index = list.findIndex(itemId => itemId === id);
  const result = [...list];
  if (index === -1) {
    result.push(id);
  } else {
    result.splice(index, 1);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/utils/arrayModify.js